module.exports = __webpack_public_path__ + "static/img/top_logo.10e7dd71.png";